import { useState } from "react";
import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";
import { Plus, Minus } from "lucide-react";

const faqs = [
  { q: "How much does bed bug treatment cost?", a: "Pricing depends on the size of the property, number of bedrooms and treatment requirements. We provide a clear quote based on the details you give us when booking." },
  { q: "How quickly can you come?", a: "We aim to schedule treatments as quickly as possible. Availability depends on demand and your location within Vancouver and the Lower Mainland." },
  { q: "Do I need to prepare before treatment?", a: "Yes. Proper preparation is essential. You'll receive clear preparation instructions before our technician arrives." },
  { q: "How long does treatment take?", a: "Treatment time depends on the size of the property and the extent of the treatment required." },
  { q: "Do I need to leave during treatment?", a: "In most cases people and pets should leave during treatment and stay out until the product has dried and the area is safe to re-enter, per the aftercare instructions." },
  { q: "What should I do with my bedding?", a: "Strip all bedding and launder linens according to the instructions we provide. Keep cleaned bedding sealed and separate until treatment is complete." },
  { q: "Do I need to throw away my mattress?", a: "Not usually. Mattresses are commonly treated rather than discarded. We'll advise based on the situation." },
  { q: "Can bed bugs spread between condo units?", a: "Bed bugs can move between connected living environments. Multi-unit coordination is available for property managers." },
  { q: "Do you treat hotels and Airbnb properties?", a: "Yes. We provide commercial bed bug treatment for hotels and short-term rental properties." },
  { q: "Will I need a follow-up treatment?", a: "Where applicable, a follow-up treatment is arranged according to the treatment program." },
  { q: "Do you offer discreet service?", a: "Yes. Our service is professional, respectful and discreet to avoid unnecessary attention from neighbours, guests or other residents." }
];

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="border-b border-border bg-muted/30 px-5 py-24 lg:px-8 lg:py-32">
      <div className="mx-auto max-w-3xl">
        <SectionHeader kicker="FAQ" title="QUESTIONS, ANSWERED." />
        <div className="mt-12 divide-y divide-border border-y border-border">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q}>
                <button id={`faq-btn-${i}`} onClick={() => setOpen(isOpen ? -1 : i)} className="flex w-full items-center justify-between gap-6 py-5 text-left rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring" aria-expanded={isOpen} aria-controls={`faq-panel-${i}`}>
                  <span className="font-heading text-base font-semibold text-primary sm:text-lg">{f.q}</span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-border" aria-hidden="true">
                    {isOpen ? <Minus className="h-3.5 w-3.5" /> : <Plus className="h-3.5 w-3.5" />}
                  </span>
                </button>
                <div id={`faq-panel-${i}`} role="region" aria-labelledby={`faq-btn-${i}`} aria-hidden={!isOpen} className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr] pb-6 opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                  <div className="overflow-hidden">
                    <p className="text-sm leading-relaxed text-muted-foreground">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}